{
  "name": "taxi-client",
  "version": "2.2.12",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 127.0.0.1",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.1",
    "@angular/cdk": "^21.0.1",
    "@angular/common": "^21.0.1",
    "@angular/compiler": "^21.0.1",
    "@angular/core": "^21.0.1",
    "@angular/forms": "^21.0.1",
    "@angular/material": "^21.0.1",
    "@angular/platform-browser": "^21.0.1",
    "@angular/platform-browser-dynamic": "^21.0.1",
    "@angular/router": "^21.0.1",
    "@azure/msal-angular": "^4.0.23",
    "@azure/msal-browser": "^4.27.0",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@ngrx/store": "^21.0.1 ",
    "@primeng/themes": "^20.3.0",
    "bootstrap": "^5.3.0",
    "chart.js": "^4.5.1",
    "jquery": "^3.6.1",
    "ng2-charts": "^8.0.0",
    "ng2-validation": "^4.2.0",
    "ngx-bootstrap": "^20.0.2",
    "ngx-device-detector": "^11.0.0",
    "ngx-easy-table": "^15.3.0",
    "popper.js": "^1.16.1",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.3.0",
    "rxjs": "^7.6.0",
    "tether": "^3.0.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.1",
    "@angular/cli": "~21.0.1",
    "@angular/compiler-cli": "^21.0.1",
    "@types/jasmine": "~5.1.5",
    "jasmine-core": "~5.13.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
